import React from "react";
import { BookOpen, Shield } from "lucide-react";
import { FaDiscord, FaGithub, FaLinkedin, FaXTwitter } from "react-icons/fa6";

export const Footer: React.FC = () => {
  return (
    <footer className="sticky bottom-0 z-10 w-full mt-auto border-t border-slate-200 dark:border-slate-800 bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl">
      <div className="max-w-full px-6 py-4 mx-auto">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          {/* Social Icons - Left Side */}
          <div className="flex items-center gap-4">
            <a
              href="https://github.com/antinomyhq/forge"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 transition-all duration-200 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800"
              aria-label="GitHub"
            >
              <FaGithub className="w-5 h-5" />
            </a>
            <a
              href="https://discord.com/invite/kRZBPpkgwq"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 transition-all duration-200 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800"
              aria-label="Discord"
            >
              <FaDiscord className="w-5 h-5" />
            </a>
            <a
              href="https://www.linkedin.com/company/forgecodehq/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 transition-all duration-200 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800"
              aria-label="LinkedIn"
            >
              <FaLinkedin className="w-5 h-5" />
            </a>
            <a
              href="https://x.com/forgecodehq"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 transition-all duration-200 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800"
              aria-label="X (formerly Twitter)"
            >
              <FaXTwitter className="w-5 h-5" />
            </a>
          </div>

          {/* Documentation Links - Right Side */}
          <div className="flex items-center gap-6">
            <a
              href="https://forgecode.dev/docs/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm transition-colors duration-200 text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100"
            >
              <BookOpen className="w-4 h-4" />
              Documentation
            </a>
            <a
              href="https://forgecode.dev/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm transition-colors duration-200 text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100"
            >
              <Shield className="w-4 h-4" />
              Privacy Policy
            </a>
            {/* <a
              href="https://github.com/antinomyhq/forge"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm transition-colors duration-200 text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100"
            >
              <Github className="w-4 h-4" />
              GitHub
            </a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};
